<template>
  <div class="preveri-geslo" v-if="prvaVrednost !== '' || drugaVrednost !== ''">
    <div v-if="naslov === undefined">Geslo mora vsebovati:</div>
    <div v-else>{{ naslov }}</div>
    <div v-for="(omejitev,index) in preverjenaVrednost">
      <span v-if="!(brezUjemanja && index===6)">
        <span v-if="omejitev.zadosceno" class="ikona-preverjeno"></span>
        <span class="omejitev" :class="omejitev.zadosceno ? 'krepko' : ''">
          {{ omejitev.naziv }}
        </span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: ['prvaVrednost', 'drugaVrednost', 'naslov', 'brezUjemanja'],
  emits: ['ValidacijaStatus'],
  name: 'ValidacijaVrednosti',
  data () {
    return {
      preverjenaVrednost: [
        {naziv: 'med 7 in 32 znakov', zadosceno: false},
        {naziv: 'velike črke', zadosceno: false},
        {naziv: 'male črke', zadosceno: false},
        {naziv: 'vsaj eno številko (0-9)', zadosceno: false},
        {naziv: 'brez šumnikov', zadosceno: false},
        {naziv: 'simboli dovoljeni', zadosceno: false},
        {naziv: 'ujemanje gesel', zadosceno: false}
      ],
      statusValidacije: false
    }
  },
  watch: {
    drugaVrednost: function () {
      if (this.drugaVrednost === this.prvaVrednost) {
        this.preverjenaVrednost[6].zadosceno = true
      } else {
        this.preverjenaVrednost[6].zadosceno = false
      }
      this.StatusValidacije()
    },
    prvaVrednost: function () {
      if (this.prvaVrednost.length >= 7 && this.prvaVrednost.length <= 32) {
        this.preverjenaVrednost[0].zadosceno = true
      } else {
        this.preverjenaVrednost[0].zadosceno = false
      }
      if (this.prvaVrednost.match('.*[A-Z].*')) {
        this.preverjenaVrednost[1].zadosceno = true
      } else {
        this.preverjenaVrednost[1].zadosceno = false
      }
      if (this.prvaVrednost.match('.*[a-z].*')) {
        this.preverjenaVrednost[2].zadosceno = true
      } else {
        this.preverjenaVrednost[2].zadosceno = false
      }
      if (this.prvaVrednost.match('.*[0-9].*')) {
        this.preverjenaVrednost[3].zadosceno = true
      } else {
        this.preverjenaVrednost[3].zadosceno = false
      }
      if (this.prvaVrednost.match('.*[\u00A1-\uFFFF].*')) {
        this.preverjenaVrednost[4].zadosceno = false
      } else {
        this.preverjenaVrednost[4].zadosceno = true
      }
      if (this.prvaVrednost.match('[+!"#$%&\'()*+,-.\\/:;<=>?@[\\]^_`{|}~]')) {
        this.preverjenaVrednost[5].zadosceno = true
      } else {
        this.preverjenaVrednost[5].zadosceno = false
      }
      if (this.prvaVrednost === this.drugaVrednost) {
        this.preverjenaVrednost[6].zadosceno = true
      } else {
        this.preverjenaVrednost[6].zadosceno = false
      }
      this.StatusValidacije()
    }
  },
  methods: {
    StatusValidacije () {
      this.statusValidacije = true
      for (let i = 0; i <= this.preverjenaVrednost.length; i++) {
        if (this.preverjenaVrednost[i] && this.preverjenaVrednost[i].zadosceno === false && i !== 5) {
          this.statusValidacije = false
        }
      }
      this.$emit('ValidacijaStatus', this.statusValidacije)
    }
  }
}
</script>
<style src="../../../../../../static/css/moj_profil/ValidacijaVrednosti.css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Mojprofil/Varnost/ValidacijaVrednosti.vue